import { render, staticRenderFns } from "./ygsh.vue?vue&type=template&id=04c85f46&scoped=true&"
import script from "./ygsh.vue?vue&type=script&lang=js&"
export * from "./ygsh.vue?vue&type=script&lang=js&"
import style0 from "./ygsh.vue?vue&type=style&index=0&id=04c85f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c85f46",
  null
  
)

export default component.exports